/* Five Origins — Academia FOCA
   Pașaport (boabe, ranguri, ștampile), trasee de întrebări, diplomă.
   Starea trăiește în localStorage-ul vizitatorului. Fără cont, fără server. */
(function () {
  'use strict';

  var root = document.querySelector('[data-foa]');
  if (!root) return;

  /* punte către fo-academy-diploma.js (diplomă + distribuire) */
  var API = (window.FOA = window.FOA || {});

  var KEY = 'fo_academy_v1';
  var DATA = null;

  /* ---------- stare ---------- */
  function load() {
    var s = { beans: 0, name: '', tracks: {} };
    try {
      var raw = localStorage.getItem(KEY);
      if (raw) {
        var p = JSON.parse(raw);
        if (p && typeof p === 'object') {
          s.beans = +p.beans || 0;
          s.name = typeof p.name === 'string' ? p.name : '';
          s.tracks = (p.tracks && typeof p.tracks === 'object') ? p.tracks : {};
        }
      }
    } catch (e) { /* mod privat, storage blocat — mergem mai departe */ }
    return s;
  }
  function save() {
    try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) { /* ignorăm */ }
  }
  var state = load();

  API.save = save;
  API.getState = function () { return state; };

  /* ---------- utilitare ---------- */
  function $(s, c) { return (c || root).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); }
  function esc(x) {
    return String(x == null ? '' : x).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function eligible(r) {
    if (!r.requireStamps) return true;
    return stampsOwned().length >= DATA.tracks.length;
  }
  function rankIndex(beans) {
    var k = 0;
    for (var i = 0; i < DATA.ranks.length; i++) {
      if (beans >= DATA.ranks[i].beans && eligible(DATA.ranks[i])) k = i;
    }
    return k;
  }
  function rankOf(beans) { return DATA.ranks[rankIndex(beans)]; }
  function nextRank(beans) { return DATA.ranks[rankIndex(beans) + 1] || null; }
  API.esc = function (v) { return esc(v); };
  API.q = function (sel) { return $(sel); };
  API.rankOf = function (b) { return rankOf(b); };
  API.stampsOwned = function () { return stampsOwned(); };
  API.data = function () { return DATA; };

  function IC() { return (window.FOA_DIPLOMA && window.FOA_DIPLOMA.icons) || {}; }

  function stampsOwned() {
    return DATA.tracks.filter(function (t) { return state.tracks[t.id] && state.tracks[t.id].done; })
                      .map(function (t) { return t.stamp; });
  }

  /* ---------- pașaport ---------- */
  function renderPassport() {
    var r = rankOf(state.beans), nx = nextRank(state.beans);
    $('[data-foa-rank]').textContent = r.name;
    $('[data-foa-beans]').textContent = state.beans + (state.beans === 1 ? ' boabă' : ' boabe');

    var owned = stampsOwned();
    var needBeans = nx ? Math.max(0, nx.beans - state.beans) : 0;
    var needStamps = (nx && nx.requireStamps) ? Math.max(0, DATA.tracks.length - owned.length) : 0;

    var pct = 100;
    if (nx) {
      if (needBeans > 0) {
        var from = r.beans, span = nx.beans - from;
        pct = span > 0 ? Math.min(100, Math.round(((state.beans - from) / span) * 100)) : 0;
      } else if (needStamps > 0) {
        pct = Math.round((owned.length / DATA.tracks.length) * 100);
      }
    }
    $('[data-foa-barin]').style.width = pct + '%';

    var msg;
    if (!nx) {
      msg = 'Ai atins ultimul rang. ' + esc(r.desc);
    } else if (needBeans > 0 && needStamps > 0) {
      msg = 'Îți mai trebuie <b>' + needBeans + ' boabe</b> și <b>' + needStamps +
            (needStamps === 1 ? ' ștampilă</b>' : ' ștampile</b>') + ' până la <b>' + esc(nx.name) + '</b>.';
    } else if (needStamps > 0) {
      msg = 'Ai destule boabe. Îți mai trebuie <b>' + needStamps +
            (needStamps === 1 ? ' ștampilă</b>' : ' ștampile</b>') + ' până la <b>' + esc(nx.name) + '</b>.';
    } else {
      msg = 'Îți mai trebuie <b>' + needBeans + ' boabe</b> până la <b>' + esc(nx.name) + '</b>. ' + esc(nx.desc);
    }
    $('[data-foa-next]').innerHTML = msg;

    var html = '';
    DATA.tracks.concat(DATA.soon.map(function (s) { return { stamp: s.name, id: null }; }))
      .forEach(function (t) {
        var on = owned.indexOf(t.stamp) > -1;
        html += '<div class="foa__st' + (on ? '' : ' off') + '">' +
          '<span class="foa__stN">' + esc(t.stamp) + '</span>' +
          '<span class="foa__stS">' + (on ? 'Obținut' : 'Blocat') + '</span></div>';
      });
    $('[data-foa-stamps]').innerHTML = html;
  }

  /* ---------- lista de trasee ---------- */
  function renderTracks() {
    var html = '';
    DATA.tracks.forEach(function (t) {
      var st = state.tracks[t.id];
      var pill = st && st.done
        ? '<span class="foa__pill done">' + st.correct + '/' + t.questions.length + '</span>'
        : '<span class="foa__pill go">' + t.minutes + ' min</span>';
      html += '<button type="button" class="foa__tr" data-foa-start="' + t.id + '">' +
        '<span class="foa__trTop"><span class="foa__trN">' + esc(t.name) + '</span>' + pill + '</span>' +
        '<span class="foa__trP">' + esc(t.lead) + '</span>' +
        '<span class="foa__trM">' + t.questions.length + ' întrebări · ștampila ' + esc(t.stamp) +
        (st && st.done ? ' · reia oricând' : '') + '</span></button>';
    });
    DATA.soon.forEach(function (s) {
      html += '<button type="button" class="foa__tr" disabled>' +
        '<span class="foa__trTop"><span class="foa__trN">' + esc(s.name) + '</span>' +
        '<span class="foa__pill">În curând</span></span>' +
        '<span class="foa__trP">' + esc(s.lead) + '</span></button>';
    });
    $('[data-foa-tracks]').innerHTML = html;
    renderExtras();
  }

  function todayKey() {
    var d = new Date();
    return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
  }
  function dailyQuestion() {
    // aceeași întrebare pentru toată lumea într-o zi, aleasă determinist din tot bazinul
    var pool = [];
    DATA.tracks.forEach(function (t) { t.questions.forEach(function (q) { pool.push(q); }); });
    if (!pool.length) return null;
    var d = new Date();
    var n = Math.floor(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()) / 86400000);
    return pool[n % pool.length];
  }

  function renderExtras() {
    var box = $('[data-foa-extra]'); if (!box) return;
    var dn = DATA.daily || {}, done = state.daily === todayKey();
    var esp = DATA.espresso || {};
    var espDone = state.espresso ? (DATA.espresso.profiles[state.espresso] || null) : null;

    box.innerHTML =
      '<div class="foa__tracks">' +
        '<button type="button" class="foa__tr" data-foa-daily ' + (done ? 'disabled' : '') + '>' +
          '<span class="foa__trTop"><span class="foa__trN">' + esc(dn.title || 'Boaba zilei') + '</span>' +
          '<span class="foa__pill ' + (done ? 'done' : 'go') + '">' + (done ? 'Luată' : '+' + (dn.beans || 10)) + '</span></span>' +
          '<span class="foa__trP">' + esc(done ? (dn.doneLead || '') : (dn.lead || '')) + '</span>' +
        '</button>' +
        '<button type="button" class="foa__tr" data-foa-espresso>' +
          '<span class="foa__trTop"><span class="foa__trN">' + esc(esp.name || 'Ce aparat ți se potrivește') + '</span>' +
          '<span class="foa__pill ' + (espDone ? 'done' : 'go') + '">' + (espDone ? 'Ai un rezultat' : '5 întrebări') + '</span></span>' +
          '<span class="foa__trP">' + esc(esp.lead || '') + '</span>' +
        '</button>' +
      '</div>';
  }

  /* ---------- boaba zilei ---------- */
  function startDaily() {
    var q = dailyQuestion(); if (!q) return;
    run = { daily: true, q: q, answered: false };
    stage.hidden = false; $('[data-foa-lists]').hidden = true;
    var opts = q.a.map(function (txt, i) {
      return '<button type="button" class="foa__opt" data-foa-dans="' + i + '">' +
        '<span class="foa__optK">' + 'ABC'.charAt(i) + '</span><span class="foa__optT">' + esc(txt) + '</span></button>';
    }).join('');
    stage.innerHTML =
      '<div class="foa__quiz">' +
        '<div class="foa__qTop"><span class="foa__qStep">Boaba zilei</span>' +
        '<button type="button" class="foa__btn foa__btn--ghost" data-foa-quit style="padding:6px 12px;font-size:.8125rem">Ieși</button></div>' +
        '<p class="foa__q">' + esc(q.q) + '</p>' +
        '<div class="foa__opts">' + opts + '</div><div data-foa-why></div>' +
      '</div>';
    stage.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  function answerDaily(i) {
    if (!run || !run.daily || run.answered) return;
    run.answered = true;
    var q = run.q, ok = i === q.correct, dn = DATA.daily || {};
    $$('[data-foa-dans]').forEach(function (b) {
      var bi = +b.getAttribute('data-foa-dans'); b.disabled = true;
      if (bi === q.correct) b.classList.add('good'); else if (bi === i) b.classList.add('bad');
    });
    var gained = 0;
    if (state.daily !== todayKey()) {
      state.daily = todayKey();
      gained = ok ? (dn.beans || 10) : Math.round((dn.beans || 10) / 2);
      state.beans += gained; save();
    }
    $('[data-foa-why]').innerHTML =
      '<p class="foa__why"><b>' + (ok ? 'Corect.' : 'Nu chiar.') + '</b> ' + esc(q.why) +
      (q.src ? '<span class="foa__src">Sursă: <a href="' + esc(q.src.url) + '" target="_blank" rel="noopener">' + esc(q.src.label) + '</a></span>' : '') + '</p>' +
      '<div class="foa__acts"><button type="button" class="foa__btn" data-foa-quit>+' + gained + ' boabe · înapoi</button></div>';
    renderPassport(); renderTracks();
  }

  /* ---------- selector de aparat ---------- */
  function startEspresso() {
    var e = DATA.espresso; if (!e) return;
    run = { esp: true, i: 0, score: {} };
    stage.hidden = false; $('[data-foa-lists]').hidden = true;
    drawEspresso();
    stage.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  function drawEspresso() {
    var e = DATA.espresso, q = e.questions[run.i];
    var segs = e.questions.map(function (_, i) {
      return '<span class="foa__seg' + (i < run.i ? ' on' : '') + '"></span>';
    }).join('');
    var opts = q.a.map(function (o, i) {
      return '<button type="button" class="foa__opt" data-foa-eans="' + i + '">' +
        '<span class="foa__optK">' + 'ABCD'.charAt(i) + '</span><span class="foa__optT">' + esc(o.t) + '</span></button>';
    }).join('');
    stage.innerHTML =
      '<div class="foa__quiz">' +
        '<div class="foa__qTop"><span class="foa__qStep">Aparatul tău · ' + (run.i + 1) + ' din ' + e.questions.length + '</span>' +
        '<button type="button" class="foa__btn foa__btn--ghost" data-foa-quit style="padding:6px 12px;font-size:.8125rem">Ieși</button></div>' +
        '<div class="foa__segs">' + segs + '</div>' +
        '<p class="foa__q">' + esc(q.q) + '</p>' +
        '<div class="foa__opts">' + opts + '</div>' +
      '</div>';
  }
  function answerEspresso(i) {
    var e = DATA.espresso, o = e.questions[run.i].a[i];
    Object.keys(o.s || {}).forEach(function (k) { run.score[k] = (run.score[k] || 0) + o.s[k]; });
    if (run.i < e.questions.length - 1) { run.i++; drawEspresso(); return; }
    var best = null, bv = -1;
    Object.keys(run.score).forEach(function (k) { if (run.score[k] > bv) { bv = run.score[k]; best = k; } });
    // volumul decide: peste 20 de cafele pe zi nu mai e o întrebare de acasă
    if ((run.score.b2b || 0) >= 10) best = 'b2b';
    var p = e.profiles[best] || e.profiles.filtru;
    state.espresso = best; save();
    stage.innerHTML =
      '<div class="foa__quiz"><div class="foa__res">' +
        '<p class="foa__resK">Recomandarea noastră</p>' +
        '<h3 class="foa__resT">' + esc(p.name) + '</h3>' +
        '<p class="foa__resP">' + esc(p.verdict) + '</p>' +
        '<div class="foa__pros">' +
          '<p class="foa__pro"><b>Ce câștigi</b>' + esc(p.good) + '</p>' +
          '<p class="foa__con"><b>Ce pierzi</b>' + esc(p.bad) + '</p>' +
          '<p class="foa__tip2"><b>Unde să dai banii</b>' + esc(p.spend) + '</p>' +
        '</div>' +
        '<p class="foa__resP">' + esc(p.coffee) + '</p>' +
        '<div class="foa__acts" style="justify-content:center">' +
          '<a class="foa__btn" href="' + esc(p.url) + '">Vezi cafelele potrivite</a>' +
          '<button type="button" class="foa__btn foa__btn--ghost" data-foa-ask="' + esc(p.name) + '">Cere o recomandare concretă</button>' +
        '</div>' +
        '<p class="foa__hint">Nu vindem aparate. Tocmai de aceea îți spunem și ce nu merge la fiecare.</p>' +
        '<div class="foa__acts" style="justify-content:center"><button type="button" class="foa__btn foa__btn--ghost" data-foa-quit>Înapoi</button></div>' +
      '</div></div>';
  }

  /* ---------- quiz ---------- */
  var run = null;
  var stage = $('[data-foa-stage]');

  function startTrack(id) {
    var t = null;
    DATA.tracks.forEach(function (x) { if (x.id === id) t = x; });
    if (!t) return;
    run = { t: t, i: 0, correct: 0, answered: false, marks: [] };
    if (t.tool === 'capsule') drawCapsuleTool(); else drawQuestion();
    stage.hidden = false;
    $('[data-foa-lists]').hidden = true;
    stage.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function drawCapsuleTool() {
    var pr = DATA.prices || { cheapKg: 167, dearKg: 318, cheapName: 'cea mai accesibilă cafea', dearName: 'cea mai scumpă cafea' };
    var t = run.t;
    stage.innerHTML =
      '<div class="foa__quiz">' +
        '<div class="foa__qTop"><span class="foa__qStep">' + esc(t.name) + ' · calculator</span>' +
        '<button type="button" class="foa__btn foa__btn--ghost" data-foa-quit style="padding:6px 12px;font-size:.8125rem">Ieși</button></div>' +
        '<p class="foa__q">' + esc(t.toolTitle || 'Calculator') + '</p>' +
        '<p class="foa__trP" style="margin:-8px 0 16px">' + esc(t.toolLead || '') + '</p>' +
        '<div class="foa__calc">' +
          '<label class="foa__f"><span>Capsule pe zi</span><input class="foa__in" id="foa-caps" type="number" min="1" max="30" step="1" value="3" inputmode="numeric"></label>' +
          '<label class="foa__f"><span>Lei pe capsulă</span><input class="foa__in" id="foa-pret" type="number" min="0.2" max="10" step="0.1" value="1.8" inputmode="decimal"></label>' +
          '<label class="foa__f"><span>Grame pe capsulă</span><input class="foa__in" id="foa-gr" type="number" min="3" max="14" step="0.5" value="5.5" inputmode="decimal"></label>' +
        '</div>' +
        '<p class="foa__why" data-foa-calcout style="border-left-color:var(--foa-stamp)"></p>' +
        '<p class="foa__hint">Capsulele Nespresso Original au în jur de 5 g; alte sisteme au mai mult. Verifică pe ambalajul tău și schimbă cifra.</p>' +
        '<div class="foa__acts"><button type="button" class="foa__btn" data-foa-tool-done>Continuă cu întrebările</button></div>' +
      '</div>';

    function fmt(n, d) {
      return Number(n).toLocaleString('ro-RO', { minimumFractionDigits: d || 0, maximumFractionDigits: d || 0 });
    }
    function calc() {
      var c = Math.max(1, +$('#foa-caps').value || 0);
      var p = Math.max(0.2, +$('#foa-pret').value || 0);
      var g = Math.max(3, +$('#foa-gr').value || 0);
      var perKg = p / (g / 1000);
      var perYear = c * p * 365;
      var kgYear = (c * g * 365) / 1000;
      var ratio = perKg / pr.cheapKg;
      $('[data-foa-calcout]').innerHTML =
        '<b>' + fmt(perKg) + ' lei pe kilogramul de cafea.</b> ' +
        'De ' + Number(ratio).toLocaleString('ro-RO', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) +
        ' ori mai mult decât ' + esc(pr.cheapName) + ', cea mai accesibilă cafea din catalogul nostru (' + fmt(pr.cheapKg) + ' lei/kg). ' +
        'Bei ' + fmt(kgYear, 1) + ' kg pe an și dai ' + fmt(perYear) + ' lei. ' +
        'Pe aceiași bani ai lua ' + fmt(perYear / pr.cheapKg, 1) + ' kg din ' + esc(pr.cheapName) +
        ' sau ' + fmt(perYear / pr.dearKg, 1) + ' kg din ' + esc(pr.dearName) + ', cea mai scumpă cafea a noastră.';
    }
    ['#foa-caps', '#foa-pret', '#foa-gr'].forEach(function (id) {
      $(id).addEventListener('input', calc);
    });
    calc();
  }

  function drawQuestion() {
    var t = run.t, q = t.questions[run.i];
    var segs = t.questions.map(function (_, i) {
      var cls = 'foa__seg';
      if (run.marks[i] === 1) cls += ' on';
      if (run.marks[i] === 0) cls += ' bad';
      return '<span class="' + cls + '"></span>';
    }).join('');
    var opts = q.a.map(function (txt, i) {
      return '<button type="button" class="foa__opt" data-foa-ans="' + i + '">' +
        '<span class="foa__optK">' + 'ABC'.charAt(i) + '</span>' +
        '<span class="foa__optT">' + esc(txt) + '</span></button>';
    }).join('');
    stage.innerHTML =
      '<div class="foa__quiz">' +
        '<div class="foa__qTop"><span class="foa__qStep">' + esc(t.name) + ' · întrebarea ' + (run.i + 1) + ' din ' + t.questions.length + '</span>' +
        '<button type="button" class="foa__btn foa__btn--ghost" data-foa-quit style="padding:6px 12px;font-size:.8125rem">Ieși</button></div>' +
        '<div class="foa__segs">' + segs + '</div>' +
        '<p class="foa__q">' + esc(q.q) + '</p>' +
        '<div class="foa__opts">' + opts + '</div>' +
        '<div data-foa-why></div>' +
      '</div>';
  }

  function answer(i) {
    if (run.answered) return;
    run.answered = true;
    var q = run.t.questions[run.i];
    var ok = i === q.correct;
    run.marks[run.i] = ok ? 1 : 0;
    if (ok) run.correct++;

    $$('[data-foa-ans]').forEach(function (b) {
      var bi = +b.getAttribute('data-foa-ans');
      b.disabled = true;
      if (bi === q.correct) b.classList.add('good');
      else if (bi === i) b.classList.add('bad');
    });
    $$('.foa__seg')[run.i].classList.add(ok ? 'on' : 'bad');

    var last = run.i === run.t.questions.length - 1;
    $('[data-foa-why]').innerHTML =
      '<p class="foa__why"><b>' + (ok ? 'Corect.' : 'Nu chiar.') + '</b> ' + esc(q.why) +
      (q.link ? ' <a href="' + esc(q.link.url) + '">' + esc(q.link.label) + ' →</a>' : '') +
      (q.src ? '<span class="foa__src">Sursă: <a href="' + esc(q.src.url) + '" target="_blank" rel="noopener">' + esc(q.src.label) + '</a></span>' : '') + '</p>' +
      '<div class="foa__acts"><button type="button" class="foa__btn" data-foa-next-q>' +
      (last ? 'Vezi rezultatul' : 'Următoarea întrebare') + '</button></div>';
    $('[data-foa-live]').textContent = ok ? 'Răspuns corect.' : 'Răspuns greșit.';
  }

  function nextQuestion() {
    if (run.i < run.t.questions.length - 1) {
      run.i++; run.answered = false; drawQuestion();
    } else {
      finish();
    }
  }

  function finish() {
    var t = run.t;
    var prev = state.tracks[t.id] || { done: false, correct: 0 };
    var gained = run.correct * t.beansPerCorrect;
    // la reluare acordăm doar diferența, ca să nu se poată aduna boabe la nesfârșit
    var already = prev.done ? prev.correct * t.beansPerCorrect : 0;
    var delta = Math.max(0, gained - already);

    var rankBefore = rankOf(state.beans);
    state.beans += delta;
    state.tracks[t.id] = { done: true, correct: Math.max(prev.correct, run.correct), at: Date.now() };
    save();
    var rankAfter = rankOf(state.beans);
    var up = rankAfter.id !== rankBefore.id;

    var perfect = run.correct === t.questions.length;
    var title = perfect ? 'Fără nicio greșeală.' : (run.correct >= t.questions.length - 2 ? 'Bine jucat.' : 'Ai ștampila.');
    var lead = perfect
      ? 'Șapte din șapte. Ștampila ' + t.stamp + ' e a ta și ai învățat ceva ce majoritatea cumpărătorilor de cafea nu știu.'
      : 'Ai răspuns corect la ' + run.correct + ' din ' + t.questions.length + '. Poți relua oricând — se păstrează cel mai bun scor.';

    stage.innerHTML =
      '<div class="foa__quiz"><div class="foa__res">' +
        '<p class="foa__resK">Traseul ' + esc(t.name) + ' · încheiat</p>' +
        '<h3 class="foa__resT">' + esc(title) + '</h3>' +
        '<p class="foa__resP">' + esc(lead) + '</p>' +
        '<div class="foa__score">' +
          '<span class="foa__sc"><span class="foa__scV">' + run.correct + '/' + t.questions.length + '</span><span class="foa__scL">Corecte</span></span>' +
          '<span class="foa__sc"><span class="foa__scV">+' + delta + '</span><span class="foa__scL">Boabe</span></span>' +
          '<span class="foa__sc"><span class="foa__scV">' + (stampsOwned().length) + '</span><span class="foa__scL">Ștampile</span></span>' +
        '</div>' +
        (up ? '<p class="foa__rankUp">Ai urcat la rangul <b>' + esc(rankAfter.name) + '</b>. ' + esc(rankAfter.desc) + '</p>' : '') +
        '<div class="foa__dip">' +
          '<label class="foa__sr" for="foa-name">Numele tău pentru diplomă</label>' +
          '<input class="foa__in" id="foa-name" type="text" maxlength="40" placeholder="Numele tău, pentru diplomă" value="' + esc(state.name) + '">' +
          '<canvas class="foa__cv" data-foa-canvas width="1400" height="990"></canvas>' +
          '<a class="foa__btn" data-foa-dl download="diploma-five-origins.png" href="#">Descarcă diploma</a>' +
          '<p class="foa__shareT">Arat-o și altora</p>' +
          '<div class="foa__share">' +
            '<button type="button" class="foa__sh foa__sh--all" data-foa-share="native" aria-label="Distribuie diploma">' + (IC().share || '') + '<span>Distribuie</span></button>' +
            '<button type="button" class="foa__sh foa__sh--fb" data-foa-share="fb" aria-label="Distribuie pe Facebook">' + (IC().fb || '') + '</button>' +
            '<button type="button" class="foa__sh foa__sh--ig" data-foa-share="ig" aria-label="Distribuie pe Instagram">' + (IC().ig || '') + '</button>' +
            '<button type="button" class="foa__sh foa__sh--wa" data-foa-share="wa" aria-label="Trimite pe WhatsApp">' + (IC().wa || '') + '</button>' +
            '<button type="button" class="foa__sh foa__sh--li" data-foa-share="li" aria-label="Distribuie pe LinkedIn">' + (IC().li || '') + '</button>' +
            '<button type="button" class="foa__sh foa__sh--cp" data-foa-share="copy" aria-label="Copiază textul">' + (IC().copy || '') + '</button>' +
          '</div>' +
          '<p class="foa__hint" data-foa-sharemsg aria-live="polite"></p>' +
          '<p class="foa__hint">Pe telefon, „Distribuie” trimite direct imaginea. Pe calculator, descarc-o întâi și apoi atașeaz-o — Instagram nu acceptă imagini prin link.</p>' +
        '</div>' +
        '<div class="foa__acts"><button type="button" class="foa__btn foa__btn--ghost" data-foa-quit>Înapoi la trasee</button></div>' +
      '</div></div>';

    renderPassport(); renderTracks();
    var nameEl = $('#foa-name');
    nameEl.addEventListener('input', function () {
      state.name = nameEl.value.slice(0, 40); save();
      if (window.FOA_DIPLOMA) window.FOA_DIPLOMA.draw();
    });
    if (window.FOA_DIPLOMA) window.FOA_DIPLOMA.draw();
    $('[data-foa-live]').textContent = 'Traseu încheiat. ' + run.correct + ' din ' + t.questions.length + ' corecte.';
  }

  /* ---------- evenimente ---------- */
  root.addEventListener('click', function (ev) {
    var el;
    if ((el = ev.target.closest('[data-foa-start]'))) { startTrack(el.getAttribute('data-foa-start')); return; }
    if ((el = ev.target.closest('[data-foa-ans]'))) { answer(+el.getAttribute('data-foa-ans')); return; }
    if (ev.target.closest('[data-foa-next-q]')) { nextQuestion(); return; }
    if (ev.target.closest('[data-foa-tool-done]')) { run.answered = false; drawQuestion(); return; }
    if (ev.target.closest('[data-foa-daily]')) { startDaily(); return; }
    if ((el = ev.target.closest('[data-foa-dans]'))) { answerDaily(+el.getAttribute('data-foa-dans')); return; }
    if (ev.target.closest('[data-foa-espresso]')) { startEspresso(); return; }
    if ((el = ev.target.closest('[data-foa-eans]'))) { answerEspresso(+el.getAttribute('data-foa-eans')); return; }
    if ((el = ev.target.closest('[data-foa-share]'))) {
      var net = el.getAttribute('data-foa-share');
      if (window.FOA_DIPLOMA) window.FOA_DIPLOMA.share(net);
      return;
    }
    if ((el = ev.target.closest('[data-foa-ask]'))) {
      var form = $('[data-foa-form]');
      if (form) {
        var hid = form.querySelector('[data-foa-ctx]');
        if (hid) hid.value = 'Academia FOCA · recomandare aparat: ' + el.getAttribute('data-foa-ask') +
                             ' · rang: ' + rankOf(state.beans).name + ' · boabe: ' + state.beans;
        form.hidden = false;
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var f = form.querySelector('input[type=text],input[type=email]'); if (f) f.focus();
      }
      return;
    }
    if (ev.target.closest('[data-foa-quit]')) {
      run = null; stage.hidden = true; stage.innerHTML = '';
      $('[data-foa-lists]').hidden = false;
      $('[data-foa-pp]').scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    if (ev.target.closest('[data-foa-reset]')) {
      if (!window.confirm('Ștergi tot progresul din pașaport? Nu se poate reveni.')) return;
      state = { beans: 0, name: '', tracks: {} }; save();
      renderPassport(); renderTracks();
      return;
    }
  });

  /* ---------- pornire ---------- */
  var src = root.getAttribute('data-foa-src');
  fetch(src, { headers: { 'Accept': 'application/json' } })
    .then(function (r) { if (!r.ok) throw new Error('content'); return r.json(); })
    .then(function (json) {
      DATA = json;
      root.querySelector('[data-foa-boot]').hidden = true;
      $('[data-foa-app]').hidden = false;
      renderPassport();
      renderTracks();
    })
    .catch(function () {
      var b = root.querySelector('[data-foa-boot]');
      if (b) b.textContent = 'Academia nu s-a putut încărca. Reîncarcă pagina, te rog.';
    });
})();
